/**
 * useLayoutEffect는 브라우저 화면을 그리기 직전에 동기적으로 실행되어 깜빡임 없이
 * DOM을 조작할 수 있지만, 서버 렌더링(SSR) 환경에는 화면 자체가 없어서 실행하면
 * React가 경고를 띄운다. 이 훅은 브라우저에서는 useLayoutEffect를, 서버에서는
 * 아무 동작도 하지 않는 useEffect를 대신 써서 그 경고를 피한다.
 * 모달 위치 계산처럼 "그리기 전에 DOM 값을 읽고 조정해야 하는" 로직에 useEffect 대신 쓴다.
 */
import * as React from 'react';

export function canUseDOM(): boolean {
  return !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
}

export const isBrowser = canUseDOM();

/**
 * useSafeLayoutEffect enables us to safely call `useLayoutEffect` on the browser
 * (for SSR reasons)
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser.
 *
 * @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 */
export const useSafeLayoutEffect = isBrowser
  ? React.useLayoutEffect
  : React.useEffect;
